import { Head, usePage } from "@inertiajs/react"
import { useStaticFeaturesStore } from "hooks/use-feature"

/**
 * StaticFeatures component manages the synchronization between Inertia page props
 * and the Zustand store for static features.
 *
 * This component serves dual purposes:
 * 1. Maintains the traditional meta tag for backward compatibility
 * 2. Updates the Zustand store to enable reactive feature checking
 *
 * The component updates the store synchronously during render to ensure that
 * components using useStaticFeature get the correct feature values immediately,
 * preventing stale values on first render after navigation.
 *
 * @component
 * @example
 * // Used automatically in AppWrapper for Inertia pages
 * {isInertiaPage() && <StaticFeatures />}
 *
 * @see {@link useStaticFeature} for consuming static features
 * @see {@link useStaticFeaturesStore} for the underlying Zustand store
 */
export function StaticFeatures() {
  const props = usePage().props
  const setFeatures = useStaticFeaturesStore(state => state.setFeatures)
  const features = props.staticFeatures || []

  setFeatures(features)

  return (
    <Head>
      {props.staticFeatures && (
        <meta
          name="convertkit_features"
          content={props.staticFeatures.join(",")}
        />
      )}
    </Head>
  )
}
